import { useCallback } from 'react';
import { CreateButton, SearchBar } from '../../components';
import { useUpdateFilterParams } from '../../hooks';
import { SimulationsFilterKeys } from '../../types';

interface SimulationsPageHeaderProps {
  // The applied search filter value from the URL.
  filterValue: string;
}

const SimulationsPageHeader = ({ filterValue }: SimulationsPageHeaderProps) => {
  const updateFilterParams = useUpdateFilterParams();

  // Submitting the search value updates the filter value in the Redux store and the URL.
  const onSubmit = useCallback(
    (value: string) => updateFilterParams({ [SimulationsFilterKeys.SEARCH]: value }),
    [updateFilterParams]
  );

  return (
    <div className="ml-auto flex gap-2">
      <SearchBar value={filterValue} onSubmit={onSubmit} />
      <CreateButton />
    </div>
  );
};

export default SimulationsPageHeader;
